import hiLocale from 'element-ui/lib/locale/lang/id'
const hi_IN ={
    dialog:{
        login:'लॉग इन करें',
        goLogin:'क्या आपके पास पहले से एक खाता मौजूद है? दाखिल करना',
        task:'कार्य',
        task2:'कार्य',
        English:'अंग्रेज़ी',
        India:'भारत',
        locked:'बंद कर दिया',
        noData:'No data yet.continue playing',
        toGuess:'To guess',
        EventName:'कार्यक्रम नाम',
        GameName:'गेम का नाम',
        BetingContent:'सट्टेबाजी की सामग्री',
        BetAamount:'बेट राशि',
        odds:'अंतर',
        Revenue:'राजस्व',
        status:'स्थिति',
        OrderNo:'आदेश संख्या',
        BackToTop:'वापस शीर्ष पर'
    },
    team:{
        index:{
            MyPromotions:'मेरे प्रचार',
            PerformanceInquiry:'प्रदर्शन पूछताछ',
            PlayersInquiry:'खिलाड़ी पूछताछ',
            Teamperformance:'टीम प्रदर्शन',
            InviteFriends:'मित्रों को आमंत्रित करें',
            enter:'कृपया खिलाड़ी आईडी दर्ज करें',
            Rank:'पद',
            promoteAccount:'बढ़ावा देना',
            teamEnter:'टीम की प्लेयर आईडी डालें',
            teamEnter2:'सीधे खिलाड़ी का नाम दर्ज करें',
            _total:'खिलाड़ी की कुल संख्या',
            _totalTEAM:'टीम की कुल संख्या',
            player:'की कुल संख्या',
            _new:'टीम के नए अतिरिक्त',
            _reg:'आज नए रजिस्ट्रार',
            increase:'सफल',
            reduce:'असफलता'

        },
        promotion:{
            record:'कमीशन वापसी का रिकॉर्ड',
            with:'कमीशन वापसी',
            green01:'कमीशन वापसी',
            green02:'नाम वापसी का रिकॉर्ड',
            green03:'कमीशन अनुपात',
            green04:'पदोन्नति ट्यूटोरियल',
            inviteFriend:'दोस्तों को आमंत्रित करें',
            inviteFriend2:'आप हर दिन नकद',
            inviteFriend3:'बोनस कमा सकते हैं',
            totalCom:'कुल कमीशन',
            totalClaimed:'दावा करने के लिए तैयार आयोग',
            todayInduction:'सीधे संबद्ध + आयोग की टीम के बराबर कमीशन',
            MyID:'मेरी पहचान',
            superID:'सुपीरियर आईडी',
            MEMBER:'टीम के सदस्यों की संख्या (नए अतिरिक्त)',
            TEAMTODY:'टीम आज का प्रदर्शन',
            PLAYERS:'खिलाड़ियों की संख्या (नए अतिरिक्त)',
            AFFILIATE:'प्रत्यक्ष संबद्ध प्रदर्शन आज',
            TODAY:'आज आयोग',
            YESTERDAY:'कल आयोग'
        },
        Inquiry:{
            affiliate:'प्रत्यक्ष संबद्ध प्रदर्शन',
            allperformance:'सभी प्रदर्शन',
            teamperformance:'टीम प्रदर्शन',
            aff_Title:'संबद्ध, टीम, सभी लाभ आपके हैं',
            Rebate_Title:'रिबेट अनुपात',
            SportSection:'खेल अनुभाग',
            LiveSection:'लाइव अनुभाग',
            SlotSection:'खांचा खंड',
            FishingSection:'मछली पकड़ने की धारा',
            LotterySection:'लॉटरी अनुभाग',
            RebateAmount:'रिबेट राशि',
            Daily:'टीम का प्रदर्शन / दैनिक',
        },
        tutorial:{
            tit01:'कैसे पैसा बनाने के लिए बढ़ावा देने के लिए',
            tit02:'प्रचार निमंत्रण कोड कहां है?',
            tit03:'रिपोर्ट और कमीशन की जाँच कहाँ करें?',
            tit04:'प्रदर्शन की गणना कैसे करें',
            tit05:'जमा और निकासी की आवश्यकता',
            tit06:'कैसे हटेंगे?',
            tit07:'कमीशन भुगतान के लिए कब तक',
            desc01:'QR कोड स्कैन करें या आमंत्रण लिंक पर क्लिक करें, इसे ब्राउज़र में खोलने के लिए चुनें, गेम डाउनलोड करने के लिए पंजीकरण करें, और इसे बढ़ावा देने के लिए अपने अनन्य QR कोड ईवेंट आमंत्रण लिंक का उपयोग करें।',
            desc02:"दोस्तों को आमंत्रित करने के लिए क्लिक करें, और आपके पास अपना विशिष्ट क्यूआर कोड और पंजीकरण लिंक होगा। इस तरह से पंजीकृत सदस्य आपके प्रत्यक्ष खिलाड़ी और डाउनलाइन बन सकते हैंआपके द्वारा आमंत्रित किए गए सदस्य आपके प्रत्यक्ष टीम के सदस्य होंगे। और भी कई, असीमित विकास प्राप्त किया जा सकता है।",
            desc03:'टीम पेज आपकी टीम के सदस्यों, टीम कंपनी की शुद्ध जीत, प्रत्यक्ष सदस्यों, प्रत्यक्ष सहबद्ध प्रदर्शन, इतिहास कुल आयोग और उपलब्ध कमीशन और इतने पर जांच कर सकता है।',
            desc04:'प्रदर्शन खिलाड़ियों के वैध दांव को दर्शाता है। उदाहरण के लिए, आप एक खिलाड़ी को आमंत्रित करते हैं, वह 500 जीतता है और अगली शर्त पर 300 हार जाता है, उसका प्रदर्शन 800 है।',
            desc05:'सदस्य केंद्र में जमा, जब 1 बार टर्नओवर खत्म हो तो निकासी उपलब्ध है।',
            desc06:'सबसे पहले, टीम पेज में कमीशन से वॉलेट में स्थानांतरण करें, फिर वापस लेने के लिए आगे बढ़ें। जिस बैंक कार्ड को आप वापस लेना चाहते हैं। उसका नाम और कार्ड सही होना चाहिए या सफलतापूर्वक वापस नहीं लिया जाएगा।',
            desc07:'कमीशन का क्रेडिट दैनिक होगा। प्रत्येक दिन 23:59 बजे रीसेट किया जाएगा। प्रदर्शन के आधार पर कमीशन कमीशन टेबल बेस को संदर्भित करेगा।',
            tabText01:'कमीशन की गणना',
            tabText02:'कुल कमीशन',
            tabText03:'निपटान का समय',
            tabMine01_1:'प्रत्यक्ष एजेंट कमीशन = कुल कमीशन अनुपात * प्रत्यक्ष सहबद्ध प्रदर्शन',
            tabMine01_2:'टीम कमीशन = (कुल कमीशन अनुपात-प्रत्यक्ष सहयोगी आयोग अनुपात) * टीम का प्रदर्शन',
            tabMine01_3:'एक आयोग = (B1direct संबद्ध आयोग + B1 टीम आयोग) + B2direct संबद्ध आयोग + B3diret सहबद्ध commssion',
            tabMine01_4:'बी 1 आयोग = सी 2 प्रत्यक्ष सहयोगी आयोग + सी 3 प्रत्यक्ष सहयोगी आयोग',
            tabMine02:'कुल कमीशन = प्रत्यक्ष सहयोगी आयोग + टीम आयोग',
            tabMine03:'आयोग ने हर दिन समझौता किया, दैनिक प्रदर्शन के आधार पर कमीशन।',
            proxyTips:'सहबद्ध आयोग अनुपात तालिका',
            perform:'प्रदर्शन कोटा',
            thousand:'प्रत्येक 10000 के लिए',
            Rebate:'रिबेट',
            Commission:'रिबेट राशि'
        }
    },
    newHome:{
        betnow:'बेट नाउ',
        login:'पहले साइन इन करें ',
        play:'खेल',
        sport:'स्पोर्ट्स',
        slot:'स्लॉट्स',
        chess:'Rummy ',
        SeeAll:'सभी देखें',
        lottery:'लॉटरी',
        live:'लाइव गेम्स',
        Help:'मदद',
        online:'ऑनलाइन सेवा',
        signup:'अभी साइनअप',
        fastPayments:'फ़ास्ट  एंड  सिक्योर  पेमेंट्स',
        Populargames:'अब फैशन में है',
        games:'खेल',
        casinoTrust:'ा कैसिनो यू कैन ट्रस्ट',
        NoMore:'और कोई मेल नहीं',
        Cicket:{
            Matches:'टेस्ट मैच',
            empty:'शर्त जोड़ने के लिए किसी भी कीमत पर क्लिक करें!',
            empty_r:'आपकी शर्त पर्ची खाली है। ',
            free:'ऑटो नवीनतम ऑड प्राप्त करते हैं',
            MyBets:'माई बेट्स',
            BetingSlip:'सट्टेबाजी पर्ची',
            Momentum:'मोमेंटम वन डे कप',
            ford:'फोर्ड ट्रॉफी 20/21',
            OneInternationals :'एक दिवसीय अंतर्राष्ट्रीय',
            TwentyBash :'ट्वेंटी 20 बिग बैश',
            Others:'अन्य'
        }
    },
    header: {
        user: 'यूजरनाम ',
        password: 'कुंजिका',
        forget: 'फॉरगॉट  योर  pwd?',
        login: 'लॉगिन ',
        register: 'रजिस्टर ',
        signup:'मेरा खाता बनाओ',
        verification: 'वेरिफिकेशन  कोड ',
        RememberMe:'रेमेम्बेर  में ',
        Deposit:'डिपाजिट ',
        ScanLogin:'लॉगिन  QR',
        APPDownload:'डाउनलोड  APP',
        MemberCenter:'मेंबर  सेण्टर ',
        mainAccount: 'मैं  अकाउंट ',
        mineAccount: 'माय  अकाउंट ',
        inEmail: 'मैसेज ',
        loginOut: 'लोग  आउट ',
        Betting: 'बेट  रिकार्ड्स ',
        withdraw: 'विथड्रॉ ',
        deposit: 'डिपाजिट ',
        transaction: 'ट्रांसक्शन  रिकॉर्ड ',
        checkUsername: 'एंटर  यूजरनाम ',
        checkpwd: 'एंटर  pwd',
        checkVrifyCode: 'एंटर  वेरिफिकेशन  कोड ',
        refresh:'रिफ्रेश ',
        seeMore:'चेक  आउट  मोरे ',
        hotDiscount:'हिट  प्रोमोज ',
        customer:'लाइव  चाट ',
        downloadUrl:'ऐप डाउनलोड करें',
        Eventhall:'प्रचार हॉल',
        Mobilebetting:'मोबाइल की बाजी',
        Mobilebettin2:'QR स्कैन करें ',
        Mobilebettin3:'हैकिंग और पुनर्निर्देशन को रोकें',
        Home:'घर',
        Away:'दूर',
        News:'समाचार',
        Confirm:'पुष्टि करें',
        exitSuccessfully:'सफलता लॉग आउट',
    },
    notify:{
        success:'सफलता',
        warning:'चेतावनी',
        error:'त्रुटि',
    },
    login:{
        userPlace: 'पासवर्ड कोन्टाइनिंग ात लीस्ट ६ लेटर्स एंड नंबर',
        passwordPlace: 'पासवर्ड कोन्टाइनिंग ात लीस्ट ६ लेटर्स एंड नंबर',
        userRules1:'उपयोगकर्ता नाम रिक्त नहीं है',
        userRules2:'पासवर्ड कोन्टाइनिंग ात लीस्ट ६ लेटर्स एंड नंबर',
        passwordRules:'उपयोगकर्ता नाम रिक्त नहीं है',
        verificationRules:'सत्यापन खाली नहीं है',
        finishContent:'पूरा भरना',
        endTitle:'खाता नहीं है ?',
        agentCode:'एजेंटकोड खाली नहीं है'	
    },
    verificationRegister:{
        realName:'कृपया दर्ज करें वास्तविक नाम',
        qq:'कृपया दर्ज करें QQ',
        wechat:'कृपया दर्ज करें wechat',
        email:'कृपया दर्ज करें ईमेल',
        phone:'कृपया दर्ज करें फ़ोन नंबर.',
        password:'कृप्या पास्वर्ड भरो',
        withdrawPassword:'कृपया दर्ज करें पासवर्ड वापस लें',
    },
    register: {
        FreeRegistration:'निःशुल्क पंजीकरण',
        ConfirmPassword:'पासवर्ड की पुष्टि कीजिये',
        ConfirmPasswordPlace:' कृपया पासवर्ड फिर से लिखें',
        open: 'खुले पर क्लिक करें',
        user: 'उपयोगकर्ता नाम',
        userPlace: 'कोन्टाइनिंग ात लीस्ट लेटर्स एंड नंबर',
        password: 'कुंजिका:',
        passwordPlace: 'कृपया फिर से पासवर्ड टाइप करें',
        phone: 'फ़ोन नंबर.:',
        phonePlace: 'फ़ोन नंबर दर्ज करें.',
        phoneRules:'फोन नंबर से कम नहीं होना चाहिए',
        phoneRules2:'फोन नंबर होना चाहिए',
        phoneTips: 'कृपया सही फोन नं।प्रमाणित करना。',
        agentCode: 'एफिलिएट ईद',
        agentPlace:'अगर कोई सहयोगी आईडी नहीं है तो इस फील्ड को खाली छोड़ दें',
        verification: 'पुष्टि संख्या:',
        verificationPlace: 'सत्यापन कोड दर्ज करें',
        rule: 'मैं कम से कम 18 वर्ष का हूँ। मैं पुष्टि करता हूं कि मैंने पढ़ा हऔर नियम और शर्तें और गोपनीयता नीति लागू करें',
        btn: 'प्रस्तुत',
        agree:'इस बात से सहमत',
        epeatPassword1:'पुष्टि करें कि पासवर्ड खाली नहीं है',
        epeatPassword2:'पासवर्ड मैच नहीं कर रहा है',
        phoneNumber1:'फोन नंबर। खाली नहीं',
        phoneNumber2:'सही फोन नं दर्ज करें.',
        Returnsignin:'अभी साइनअप करें',
        Terms:'「11ic नियम और शर्तें」',
        pleaseRead:'कृपया गोपनीयता नीति पढ़ें',
        realName:'वास्तविक नाम',
        realNamePlace:'वास्तविक नाम दर्ज करें (गैर-आवश्यक',
        realNamePlace_:'असली नाम दर्ज करें',
        realNameRules:'असली नाम खाली नहीं',
        realNameRules2:'rअसली नाम से कम नहीं',
        qq:'QQ',
        qqPlace:'QQ सं। (गैर-आवश्यक) दर्ज करें',
        qqPlace_:'QQ नंबर दर्ज करें.',
        qqRules:'QQ खाली नहीं है',
        qqRules2:'QQ से कम नहीं',
        wechat:'WeChat',
        wxPlace:'WeChat खाता दर्ज करें (गैर-आवश्यक)',
        wxPlace_:'WeChat खाता दर्ज करें',
        realwxRules:'WeChat खाली नहीं है',
        realwxRules2:'WeChat से कम नहीं',
        email:'ईमेल',
        emailPlace:'ईमेल दर्ज करें (गैर-आवश्यक)',
        emailPlace_:'ईमेल दर्ज करे',
        emailRulse:'ईमेल खाली नहीं है',
        emailRulse2:'ईमेल खाली नहीं है',
        emailRulse3:'सही ईमेल दर्ज करें',
        withdrawPassword:'पासवर्ड वापस लें',
        withdrawPasswordPlace:'वापसी निकासी (गैर-आवश्यक) दर्ज करें',
        withdrawPasswordPlace_:'वापस लेने के pwd दर्ज करें',
        withdrawPasswordRules:'pwd खाली न निकालें',
        withdrawPasswordRules2:'pwd से कम नहीं निकालें',
        allRules:'- अंक या इससे अधिक',
        Bit:'अंक',        
        Sentsuccessfully:'सफलतापूर्वक भेज दिया',
        phonecodePlace:'6 अंक ओटीपी"',
        sendingTip:'सत्यापन'
    },
    agency:{
        title: 'सहयोगी कार्यक्रम',
        affiliatesAgree: 'सहयोगी करार',
        agencyLogin: 'सहयोगी लॉगिन करें',
        agencyRegister: 'सहयोगी के रूप में पंजीकरण करें'
    },
    nav:{
        APPDownload:'आवेदन डाउनलोड',
        cricket:'क्रिकेट',
        home:'होमपेज',
        games:'खेल',
        live: 'लाइव गेम्स',
        sport:'खेल',
        slot: 'स्लॉट्स',
        discounts: 'प्रचार',
        agency:'सहबद्ध',
        ColorLight:'लाटरी',
        chess:'कार्ड खेल',
        Account:'लेखा',
        support:'सहयोग',
        team:'टीम',
        Fishing:'मछली',
        Affiliate:'संबद्ध'
    },
    
    walletlialog:{
        WALLET:'बटुआ',
        Deposit:'जमा',
        Withdraw:'निकालना',
        WalletDetails:'विवरण',
        MainAccount:' मुख्य बटुआ',
        Cancel:'बंद करे',
        NoDate:'कोई खाता डेटा नहीं!',
        refreshsuccess:'शेष राशि ताज़ा'
    },
    discounts:{
        Promotions:'प्रचार',
        details:'विवरण',
        noDiscounts: 'कोई प्रोमो नहीं',
        discountsReceived: 'बोनस का दावा करें',
        checkPlatform:'मंच का चयन करें',
        checkMoney: 'कृपया राशि दर्ज करें',
        checkMoneyPlace:'खेल राशि दर्ज करें ',
        cancel: 'रद्द करना',
        confrim:'पुष्टि करें',
        checkBisnum:'बेट स्लिप नं.',
        checkBisnum2:'बेटिंग डिपॉजिट स्लिप नं.',
        needLoin:'क्लेम बोनस में लॉग इन करें ',
        needLoin2:'क्लेम बोनस में लॉग इन करे ',
        querylevel:'टीयर स्थिति की जाँच करें',
        queryresult:'जाँच परिणाम',
        account:'उपयोगकर्ता नाम',
        currentlevel:'करंट टियर',
        Totalcumulativebets:'कुल राशि का दांव लगा',
        Accumulatedpromotionbonus:'कुल स्तरीय स्थिति बोनस',
        Accumulatedsalary:'कुल मासिक बोनस',
        AccumulatedMonthlysalary:'कुल साप्ताहिक बोनस',
        Totalbetamountrequiredforpromotion:'उन्नयन के लिए आवश्यक दांव',
        loading:'लोड हो रहा है',
        tips: 'अनुस्मारक',
        joinNow:'ज्वाइन'
    },
    forget:{
        title: 'फॉरगॉट योर पासवर्ड',
        RetrieveSMS:'एसएमएस वसूली',
        MailboxRetrieve: 'ईमेल पुनर्प्राप्ति',
        CustomerRetrieve:'ग्राहक सहायता वसूली',
        sendMsg:'सत्यापन कोड भेजें',
        checking: 'सत्यापित करें',
        finish: 'ख़त्म होना',
        userPlace:'अपने उपयोगकर्ता नाम दर्ज करें',
        phonePlace:'जुड़ा फोन नंबर दर्ज करें.',
        emailPlace:'जुड़े ईमेल दर्ज करें',
        sendPhoneMsg:'एसएमएस सत्यापन कोड भेजें',
        sendEmailCode: 'जुड़े ईमेल दर्ज करें',
        sendEmail:'ईमेल सत्यापन कोड भेजें',
        bindPhone:'कनेक्टेड फोन नंबर दर्ज करें.',
        bindEmail:'जुड़े ईमेल दर्ज करें',
        verifyPlace:'सत्यापन कोड दर्ज करें',
        tips:'',
        tips2:'सत्यापन कोड वाला एसएमएस आपके फ़ोन पर भेज दिया गया है.',
        newpwdPlace:'नया पासवर्ड दर्ज करें',
        reNewpwdPlace: 'फिर से नया पासवर्ड टाइप करें',
        check:'सत्यापित करें',
        resetSuccess:'पासवर्ड रीसेट सफलता!',
        celebrate:'बधाई! ',
        determine:'की पुष्टि',
        CustomerService: 'ग्राहक समर्थन से संपर्क',
        sendAgain:'सत्यापन कोड पुनः भेजें',
        // second: 'सेकेंड के बाद फिर से भेजें) '
    },
    mine:{
        welcome: 'स्वागत हे',
        balance: 'संतुलन',
        minecenter: 'मेरा केंद्र',
        AccountManagement:'खाता प्रबंधन',
        amountManage: 'निधि प्रबंधन',
        Betting: 'बेट रिकॉर्ड',
        welfare: 'बोनस का दावा करें',
        transaction: 'लेन-देन: बयान',
        myDiscount: 'मेरा प्रचार',
        safe: 'खाता सुरक्षा',
        inEmail: 'संदेश',
        loginOut: 'लॉग आउट',
        friend:'मित्रों को आमंत्रित करें',
        Affiliates:'सहयोगी किसी भी विधि के माध्यम से पंजीकरण कर सकते हैं',
        informationCenter:'समाचार केंद्र',
        Claimedsuccessfully:'सफलतापूर्वक दावा किया गया! बधाई आप कमाते हैं',
        beReset:'रिमाइंडर : िफ़  डेली  टास्क  रिवॉर्ड  दो  नॉट  क्लेम  ,आईटी  विल  बे  रिसेट',
        title01:'निमंत्रण टास्क',
        title02:'जमा राशि',
        title03:'खेल टास्क',
        Complete:'पूर्ण',
        EarnReward:'इनाम कमाना',
        Invite:'आमंत्रित करें',
        PlayGame:'खेल खेलें',
        laest_D:{
            cancel_B:'क्या आप जमा को रद्द करना सुनिश्चित करते हैं?',
            revoked:'आपका आवेदन निरस्त कर दिया गया है!',
            Reminder:'अनुस्मारक: एकाधिक अनुरोध को निलंबित कर दिया जाएगा',
            Friendly:'मित्रवत अनुस्मारक',
            Youslip:'आपके पास अभी भी अप्राप्त जमा हैं, कृपया अनुमोदन के लिए प्रतीक्षा करें या अपनी जमा पर्ची रद्द करें',
            confirmed:'की पुष्टि की',
            no:'नहीं न',
            yes:'हाँ',
            orderNo:'आदेश संख्या',
            Date:'तारीख',
            Type:'प्रकार',
            Amount:'रकम',
            ID:'ईद',
            status:'स्थिति',
            action:'कार्य'
         },
        center: {
            account: 'लेखा',
            username: 'उपयोगकर्ता नाम',
            balance: 'balance',
            money: 'INR',
            name: 'नाम',
            verification: 'अब सत्यापित हो जाओ',
            phone: 'फ़ोन',
            email: 'ईमेल',
            draw: 'भरें',
            wechat: 'WeChat',
            tips: 'अनुस्मारक',
            congratulations: 'बधाई हो',
            success: 'सफलता',
            qqConfirm: 'QQ सत्यापित करें',
            qqrule: 'एक vaild QQ दर्ज करें',
            qqPlace: 'अपना QQ दर्ज करें',
            wechatConfirm: 'WeChat सत्यापित करें',
            wechatrule: 'अपने WeChat दर्ज करें',
            wechatPlace: 'अपने WeChat दर्ज करें',
            cancel: 'रद्द करना',
            confrim: 'पुष्टि करें'
        },
        capital:{
            account: 'खाता विवरण',
            deposit: 'जमा',
            latestDeposit:'नवीनतम जमा',
            ContinuePayment:'भुगतान जारी रखें',
            revoke:'वापस लेना',
            withdraw: 'निकालना',
            bankList: 'बैंक खाता प्रबंधन',
            withdrawal: 'विथड्रॉ  रिक्वेस्ट',
            lockAmount: 'बंद विवरण',
            accountin: {
                balance: 'संतुलन',
                refresh: 'ताज़ा करना',
                accountBalance: 'मुख्य खाता',
                deposit: 'जमा',
                withdraw: 'निकालना',
                takeBack: 'वापस लेलो',
                AvailBalance: 'उपलब्ध शेष राशि',
                mainBalance: 'मुख्य',
                money: 'INR',
                RMB: 'RMB',
                describe: 'कोई खाता डेटा नहीं!',
                describe2: 'खेलना बंद',
                refreshSuccess: 'ताज़ा किया',
                takeBacking: 'वापस ले रही है',
                takeBackError: 'टेकबैक त्रुटि',
                gameBalance:'खेल खाता राशि',
            },
            depositin: {
                deposit: 'जमा',
                nocheck:'कोई भुगतान विकल्प नहीं',
                limit: 'जमा राशि:',
                limit2: ' प्रति लेन-देन सीमा:',
                money: 'INR',
                Previous:'पिछला',
                Recharge:'सबसे पहले जमा करें',
                returns:' वापसी',
                Recharge1:' जमा राशि की सिफारिश',
                Recharge2:'कृपया जमा करें',
                Recharge3:' जमा राशि',
                Recharge4:'कृपया जमा राशि का मान दर्ज करें',
                choseBank: '请选择第三方支付银行',
                typeofpayment: 'भुगतान का प्रकार',
                bank:{
                    title1:'1，अनुरोध फॉर्म भरें',
                    title2:'2，किया हुआ',
                    title3:'जमा करने से पहले सुनिश्चित करें',
                    copy:'प्रतिलिपि',
                    Bank:'पीछे का नाम',
                    Beneficiary:'लाभार्थी',
                    Account:'लेखा',
                    Cancel:'रद्द करना',
                    Next:'आगे',
                    successTitle1:'भेजा गया जमा अनुरोध रद्द करें',
                    successTitle2:'अंतर बैंक हस्तांतरण: जमा आपके खाते में दिखाई देग30 मिनट बाद। अगर आपको फंड मिलने के बाद 24 घंटे के भीतर फंड नहीं मिला हसंसाधित किया गया है, कृपया ग्राहक सहायता से संपर्क करें!',
                    orderNumber:'लेनदेन सं.',
                    DepositorName:'जमाकर्ता',
                    Amount:'रकम',
                    done:'किया हुआ',
                    dialogTitle:'कृपया हस्तांतरण जानकारी की पुष्टि करें',
                    UP:'रसीद अपलोड करें',
                    Confirmed:'की पुष्टि',
                    copysuccess:'सफलता की प्रतिलिपि बनाई गई',
                    pleaseAmount:'जमा राशि दर्ज करें',
                    pleaseName:'जमाकर्ता नाम दर्ज करें',
                    pleaseImgUrl:'रसीद अपलोड करें',
                    subsuccess:'सफलता',
                    suberr:'अनुत्तीर्ण होना'
                    
                },
                nobank:{
                    PayGate:'लाभप्रद हिसाब या लाभदायी हिसाब',
                    FEE:'fee',
                    CollectionAccount:'रिसीवर का क्यूआर कोड',
                    copy:'प्रतिलिपि',
                    Cancel:'रद्द करना',
                    complete:'आराम से स्थानांतरण',
                    orderNumber:'लेनदेन सं.',
                    Submmit:'समय',
                    Amount:'रकम',
                    Transfer:'स्थानांतरण',
                    title1:'केवल इसके लिए लागू है। कृपया अगला लेनदेन जांचें.',
                    title2:'जमा अनुरोध भेजा गया',
                },
                checkform:{
                    Depositlimit:'जमा की सीमा',
                    Amount:'रकम',
                    DepositorName:'निक्षेपागार नाम',
                    UP:'रसीद अपलोड करें',
                    UPtips:'छवि का आकार MB 1 एमबप्रारूप: JPG, PNG, GIF, BMP',
                    chenkAmount1:'सकारात्मक पूर्णांक राशि दर्ज करें',
                    chenkAmount2:'से कम नहीं',
                    chenkAmount3:'से अधिक नहीं',
                    UPmessage:'सफलता अपलोड',
                    err1:'गलत प्रारूप!',
                    err2:'आकार 1MB से बड़ा नहीं है!',
                    Transferamount: 'स्थानांतरण राशि',
                    TransferUSDTAmount: 'आप यूएसडीटी राशि ट्रांसफर करना चाहते हैं',
                    RupeeAmount: 'रुपये की राशि मंजूर करेंगे'
                },
            },
            withdrawalin: {
                title: 'निकासी की राशि',
                amountPlace: 'निकासी राशि दर्ज करें',
                refresh: 'ताज़ा संतुलन',
                AvailBalance: 'उपलब्ध शेष राशि：',
                amount: 'रकम',
                tips: 'स्वीकार्य से अधिक निकासी {min} और दशमलव से बचें',
                withdrawPassword:'पासवर्ड वापस लें',
                choseBankCard: 'बैंक का चयन करें',
                Please:'कृपया चुने',
                loading: 'लोड हो रहा है',
                addBankCard: 'बैंक कार्ड जोड़ें',
                tips2: 'अनुस्मारक: पासवर्ड और फोन वापस लेने की आवश्यकता हवापस लेने से पहले सत्यापन',
                next: 'आगे',
                diatitle: 'वापसी पासवर्ड दर्ज करें',
                diaPlace: 'कृपया पासवर्ड वापस लें',
                confrim: 'पुष्टि करें',
                confrim1Title: 'पासवर्ड वापस न लें, क्या आप पासवर्ड सेट करना चाहते हैं?',
                confrim2Title: 'फोन नं। सत्यापन से पहले, अब सत्यापित करें?',
                confrimTips: 'अनुस्मारक',
                confirmText: 'पुष्टि करें',
                cancelText: 'रद्द करना',
                wpandmb2:'कृपया बैंक खाते को बाँधने से पहले मोबाइल नंबर और निकासी पिन भरें',                
                wpandmb:'बैंक खाते को फोन नंबर सत्यापन की आवश्यकता है और वापसी पासवर्ड सेट करें, जारी रखें',
                choseBank: 'एक बैंक चुनें',
                choseAmount: 'स्वीकार्य वापसी और ',
                choseAmount2: 'से ज्यादा_____',
                noBalance: 'अपर्याप्त शेष',
                noPoint: 'दशमलव से बचें',
                nopwd: 'वापसी पासवर्ड दर्ज करें',
                withdrawSuccess: 'अनुरोध भेजा गया, अनुमोदन की प्रतीक्षा करें',
                refreshSuccess: 'सफलता ताज़ा हुई'
            },
            bankListin: {
                title1: 'बैंक सूचियों की जाँच करें',
                title2: 'बैंक खाता जोड़ें',
                loading: 'लोड हो रहा है',
                tips1: 'बैंक खाते को हटाने के लिए ग्राहक सहायता से संपर्क करें, हां या नहीं?',
                addBankCard: 'बैंक खाता जोड़ें',
                bankUser: 'कार्ड धारक',
                littleTips: 'अनुस्मारक',
                nameOnce: 'कार्ड धारक का नाम सत्यापित वास्तविक नाम और के साथ पालन करना चाहिएकेवल एक बार सेट किया जा सकता है। जरूरत पड़ने पर संशोधित करने के लिए ग्राहक सहायता से संपर्क करें ',
                namePlace: 'कार्ड धारक का नाम दर्ज करें',
                bankNum: 'बैंक खाता',
                bankTips: 'एक मान्य बैंक खाता संख्या दर्ज करें। या त्रुटि प्रदर्शित करें',
                bankPlace: 'बैंक खाता दर्ज करें',
                bankName: 'बैंक का नाम',
                PbankName: 'बैंक चुनें',
                bankNamePlace: 'बैंक का नाम दर्ज करें',
                subbranch: 'IFSC कोड',
                subbranchPlace: 'खाता बैंक शाखा में दर्ज करें',
                Mobile:'बैंक बाइंडिंग फोन',
                Mobiletitle:'खाता बैंक फोन नं.',
                password: 'वापसी पासवर्ड सेट करें',
                passwordPlace: ' वापसी पासवर्ड दर्ज करें',
                add: 'जोड़ना',
                confirmTitle: 'बैंक खाते को बाइंड करने से पहले पासवर्ड वापस लेने की जरूरत है, क्या आप पासवर्ड सेट करना चाहते हैं?',
                confirmTips: 'अनुस्मारक',
                confirmText: 'पुष्टि करें',
                cancelText: 'रद्द करना',
                Cancel:'रद्द करना',
                OK:'की पुष्टि',
                cantBank: 'अब बैंक खाता जोड़ने में असमर्थ है',
                addSuccess: 'सफलता जोड़ें',
                Required:'खाली नहीं',
                bkNbrules:'10-50 अंक होना चाहिए',
            },
            withdrawListlis: {
                loading: 'लोड हो रहा है',
                search: 'खोज',
                time: 'समय',
                amount: 'रकम',
                status: 'स्थिति',
                bankName: 'बैंक का नाम',
                bankNumber: 'बैंक खाता नम्बर.',
                remark: 'टिप्पणी',
                statusAll: 'सब',
                applying: 'आवेदन करने वाले',
                payment: 'प्रसंस्करण',
                success: 'सफलता',
                reject: 'इंकार कर दिया'
            },
            lockAmountin: {
                rechargeLock: 'आपकी जमा राशि लॉक है',
                allStates: 'सब',
                lockIn: 'बंद करना',
                Unlocked: 'अनलॉक हो गया है',
                Cancelled: 'रद्द',
                order: 'आदेश संख्या.',
                principal: 'राजधानी',
                lockInAmount: 'बंद राशि',
                targetFlow: 'टर्नओवर लक्ष्य ',
                flowComple: 'कारोबार पूरा हुआ',
                lockStatus: 'ताला की स्थिति',
                handle: 'संचालित',
                deblocking: 'अनलॉक',
                discountsLock: 'प्रचार ताला',
                allPlatform: 'सभी प्लेटफार्मों',
                mainAccount: 'मुख्य खाता',
                bonusName: 'बोनस शीर्षक',
                bonusType: 'बोनस प्रकार',
                platform: 'मंच',
                bonusLockStatus: 'बोनस लॉक की स्थिति',
                deblockingSuccess: 'अनलॉक हो गया है'
            }
        },
        betlist: {
            allPlatform: 'सभी प्लेटफार्मों',
            bizNo: 'शर्त पर्ची नं.',
            platformCode: 'प्लेटफ़ॉर्म कोड',
            gameType: 'खेल का प्रकार',
            betAmount: 'बेट राशि',
            betAmount2: 'बेट राशि:',
            betflow: 'वैध राश ि ',
            betflow2: 'वैध राशि:',
            resultAmount: 'मुनाफे',
            resultAmount2: 'मुनाफे:',
            betTime: 'बेट समय',
            createTime: 'सेटल टाइम',
            selectTime: 'समय स्लॉट चुनें',
            nobetlist:'暂无投注记录！',
            all:'सब',
        },
        billDetail: {
            toady: 'आज',
            yesterday: 'बिता कल',
            finalWeek: 'आखिरी 7 दिन',
            finalMonth: 'पिछले 30 दिनों में',
            allType: 'सब',
            SystemTransfer: 'सिस्टम समायोजन',
            RepaidDeposit: 'जमा करें',
            withdrawals: 'जल्दी वापस करो',
            SwitchToGame: 'खेल के लिए आयात',
            GameOut: 'खेल के लिए निर्यात करें',
            discounts: 'प्रमोशन बोनस',
            ManualDeposit: 'मैनुअल जमा',
            ManualRemoval: 'मैनुअल वापस लेना',
            Betting:'शर्त',
            Payout:'भुगतान',
            applying:'आवेदन करने वाले',
            transNo: 'आदेश संख्या.',
            orderName: 'आदेश शीर्षक',
            orderTime: 'समय',
            payType: 'सौदे का प्रकार',
            amount: 'रकम',
            status: 'स्थिति'
        },
        myDiscountin: {
            title: 'मेरा प्रचार',
            allType: 'सभी प्रकार',
            applying: 'आवेदन करने वाले',
            successfulCollection: 'सफलता मिली',
            finishFlow: 'कारोबार पूरा हुआ',
            cancel: 'इंकार कर दिया',
            Clearance: 'निकासी',
            Unclaimed: 'लावारिस',
            noPrize: 'सम्मानित नहीं किया गया',
            noOffer: 'कोई प्रोमो नहीं',
            clickApply: 'आवेदन करने के लिए क्लिक करें',
            discountItem: {
                needLaveBetflow: 'टर्नओवर को THB प्लेटफॉर्म पर कैश आउट करने की अनुमति दी गई',
                needLaveBetflow2: 'टर्नओवर को THB प्लेटफॉर्म पर कैश आउट करने की अनुमति दी गई',
                flowDone: 'टर्नओवर तक पहुंच गया',
                loseEfficacy: 'अमान्य'
            }
        },
        safein: {
            realName:'वास्तविक नाम',
            email:'ईमेल पता',
            phone:'फ़ोन',
            bankcard:'बैंक खाता',
            emailTitle: 'ई - मेल सत्यापन',
            emailSubTitle: 'पासवर्ड रिकवरी और पहचान के उद्देश्य से',
            nameTitle: 'असली नाम सत्यापन',
            nameSubTitle: 'व्यक्तिगत विवरण की पुष्टि करें',
            phoneTitle: 'अपना फ़ोन नंबर लिंक करें.',
            vipTitle: 'लॉग इन पासवर्ड',
            codeTitle: 'पासवर्ड वापस लें',
            revisecodeTitle: 'वापसी पासवर्ड को संशोधित करें',
            codeSubTitle: 'अपने खाते की सुरक्षा करें ',
            bankTitle: 'बैंक कार्ड लिंक करे{length}',
            management:'प्रबंधन',
            revise: 'संशोधन',
            authen: 'सत्यापित करें',
            set: 'सेट',
            receive: 'दावा',
            start: 'सक्रिय',
            customer: 'संशोधित करने के लिए ग्राहक सहायता से संपर्क करें',
            sendcode:'सत्यापन कोड भेजा गया',
            alterAction:'संशोधन को ग्राहक सेवा से संपर्क करने की आवश्यकता है, {str}क्या आप जारी रखना चाहते हैं?',
            confirmText: 'पुष्टि करें',
            cancelText: 'रद्द करना',
            common1:'कृपया फ़ोन नंबर सत्यापन पूरा करें',
            common2:'सफलता! बोनस रिलीज कृपया मेरा प्रचार जांचें',
            common3:'अज्ञात सिस्टम त्रुटि ',
            Resend:' सेकंड के बाद फिर से भेजें',
            Congratulations:'बधाई हो',
        },
        verifyEmail:{
            title:'ईमेल पता लिंक करें',
            subTitle1:'ईमेल पता दर्ज',
            subTitle2:'पुष्टि संख्या',
            sendcode:'सत्यापन कोड भेजें',
            suffix: '____ सेकंड के बाद फिर से भेजें',
            cancel:'रद्द करना',
            confrim: 'पुष्टि करें',
            tips:'1.आपके फ़ोन पर सत्यापन कोड वाला एक ईमेल भेजा गया है।यदि प्राप्त नहीं हुआ है, तो कृपया सत्यापन कोड भेजें क्लिक करें।.',
            tips2:'2.नोट: ईमेल स्पैम के लिए गलत हो सकता है; कृपया स्पैम फ़ोल्डर की भी जाँच करें',
            emailHadSend:'ईमेल भेजा ',
            emailConfrim:'ई - मेल सत्यापन',
        },
        verifyName:{
            title:'असली नाम और आईडी सत्यापन',
            subTitle1:'असली नाम दर्ज करें',
            subTitle2:'आईडी नंबर दर्ज करें.',
            cancel:'रद्द करना',
            confrim: 'पुष्टि करें',
            tips:'अपने कानूनी अधिकारों और खाता सुरक्षा की रक्षा के लिए वास्तविक नाम और आईडी सत्यापन',
            nameConfrim:'वास्तविक नाम सत्यापन',
        },
        verifyPhone:{
            title:'फोन नंबर लिंक करें.',
            subTitle1:'फ़ोन नंबर दर्ज करें.',
            subTitle2:'सत्यापन कोड दर्ज करें',
            sendcode:'सत्यापन कोड भेजें',
            suffix: 'सेकंड के बाद फिर से भेजें',
            cancel:'रद्द करना',
            confrim: 'पुष्टि करें',
            modify:"संशोधित",
            modifyph:"फोन नं.",
            tips:'यदि आप अपने खाते को पुनर्प्राप्त करने के लिए उपरोक्त जानकारी का उपयोग करते हैअपना उपयोगकर्ता नाम और पासवर्ड भूल जाएं।.',
            mileHadSend:'एसएमएस भेजा गया',
            phoneConfrim:' फोन नंबर। सत्यापन ',
        },
        loginPassword:{
            title:'लॉगिन पासवर्ड बदलें',
            subTitle1:'पुराना पासवर्ड डालें',
            subTitle2:'नया पासवर्ड दर्ज करें',
            subTitle3:'नए पासवर्ड की पुष्टि करें',
            cancel:'रद्द करना',
            confrim: 'परिवर्तन',
            tips:'Remark:पासवर्ड गोपनीय रखें। यदि आप अपना पासवर्ड भूल गए हैं, तो आप पासवर्ड रिकवरी टूल का उपयोग कर सकते हैं या ग्राहक सहायता से संपर्क कर सकते हैं',
            pleaseLogin:'फिर से लॉगिन करें',
            oldpwdError:'पुराना पासवर्ड त्रुटि प्रारूप',
            pwdError: 'नया पासवर्ड त्रुटि प्रारूप',
            pswIsChange:'change login pwd'
        },
        setPassword:{
            title:'वापसी पासवर्ड सेट करें',
            subTitle1:'सत्यापित फोन नंबर दर्ज करें.',
            phoneFirst: 'कृपया अपना फ़ोन नंबर सत्यापित करें.',
            subTitle2:'सत्यापन कोड दर्ज करें',
            subTitle3:'वापसी पासवर्ड दर्ज करें',
            subTitle4:'नए पासवर्ड की पुष्टि करें',
            sendcode:'सत्यापन कोड भेजें',
            suffix: '___ सेकंड के बाद फिर से भेजें',
            cancel:'रद्द करना',
            confrim: 'पुष्टि करें',
            tips:'टिप्पणी: पासवर्ड गोपनीय रखें। यदि आप भूल गए हैं, तो कृपया ग्राहक सहायता से संपर्क करें ',
            mileHadSend:'एसएमएस भेजा गया',
        },
        changePassword:{
            title:'वापसी पासवर्ड बदलें',
            subTitle1:'सत्यापित फोन नंबर दर्ज करें.',
            phoneFirst: 'वापसी पासवर्ड दर्ज करें',
            subTitle2:'सत्यापन कोड दर्ज करें',
            subTitle3:'पुराना निकासी पासवर्ड दर्ज करें',
            subTitle4:'नया निकासी पासवर्ड दर्ज करें',
            subTitle5:'नए निकासी पासवर्ड की पुष्टि करें',
            sendcode:'सत्यापन कोड भेजें',
            suffix: ' सेकंड के बाद फिर से भेजें',
            cancel:'रद्द करना',
            confrim: 'पुष्टि करें',
            tips:'टिप्पणी: पासवर्ड गोपनीय रखें। यदि आप भूल गए हैं, तो कृपया ग्राहक सहायता से संपर्क करें',
            mileHadSend:'एसएमएस भेजा गया',
        },
        email:{
            title:'संदेश',
            mineMsg: 'मेरा संदेश',
            newMsg: 'ताज़ा खबर',
            hasRead: 'संदेश पढ़ना',
            noMsg: 'कोई सन्देश नहीं' ,
            del:'हटाना',
            sendMsg:'नया संदेश भेजें',
            msgType:'संदेश प्रकार：',
            please:'चुनते हैं',
            pleaseCheck:'प्रश्न प्रकार चुनें',
            mine:'मुख्य विषय पंक्ति:',
            minePlease: 'विषय पंक्ति इनपुट करें',
            content: 'सामग्री:',
            contentPlaese:'इनपुट सामग्री',
            send:'भेजने',
            question1:'जमा करें और जमा करें',
            question2:'प्रचार',
            question3:'खेल संबंधी',
            question4:'दूसरा प्रश्न',
            question5:'सुझाव',
            question6:'शिकायत',
            checkInfo:'चयनित संदेश हटाएं',
            delSuccess:'नष्ट की गई सफलता',
            submitSuccess:'प्रस्तितु सफल है',
            finishContent:'पूरा भरना'
        }
            

    },
    game:{
        playNow:'अब खेलें',
        comingSoon:'जल्द आ रहा है ',
        realMoney: 'असली पैसे',
        try: 'मुफ्त शर्त',
        noData:'कोई आकड़ा उपलब्ध नहीं है'
    },
    slot:{
        gameSearch:'खोज का खेल',
        reset:'रीसेट',
        mineCollect: 'मेरा संग्रह',
        mineCollect2: 'कोई संग्रह नहीं',
        gameLobby: 'खेल लॉबी:',
        gameTypes:'खेल का प्रकार',
        hotGame:'热门游戏',
        newGame:'शीर्ष हिट',
        recommend: 'सिफारिश',
        all:'सब',
        PrizePoolGame:'जैकपॉट स्लॉट',
        classicGame:'क्लासिक',
        xxl:'रूसी टेट्रिस',
        electricHorn: 'वीडियो स्लॉट',
        line:'लाइन',
        pleaseEnter:'खेल के लिए खोज',
        add:'पसंदीदा लिस्ट मे डालें',
        addSuucess:'पसंदीदा सफलता में जोड़ें',
        cancelSuccess:'पसंदीदा से निकालें',
        hadCollect:'जुटाया हुआ',
        late:'बाद में पुन: प्रयास करें',
        noLogin:'लॉगिन के बाद पसंदीदा में जोड़ें',
        hotGameRank:'लोकप्रिय खेल रैंकिंग',
        loading: 'लोड हो रहा है',
        gogame: 'एक खेल दर्ज करें',
        describe: 'लॉगिन के बाद जांच करें',
        title1:'हाल में ही देखा गया',
        title2:'आपको यह भी पसंद आ सकता हैं',
    },
    footer:{
        webSlogan:'संपर्क करें',
        MENU:'मेन्यू',
        INFORMATION:'उपयोगी कड़ियाँ',
        LINKS:'त्वरित सम्पक',
        Game:'GAME PROVIDERS',
        Introduction:'एक विजेता टीम का हिस्सा बनें! 11ic पुरस्कृत सहबद्ध कार्यक्रम में शामिल हों और अपने प्रत्येक संदर्भित ग्राहकों के लिए पैसा कमाएं। जितने अधिक खिलाड़ी होते हैं, उतने अधिक आप राजस्व हिस्सेदारी रैंक के माध्यम से आगे बढ़ते हैं।',
        Introduction02:'जुआ से जुड़ी अधिक जानकारी या पूछताछ के लिए, हमारे जिम्मेदार गेमिंग गाइड का संदर्भ लें।',
        Introduction03:'जो भी प्रतिभागी कमज़ोर हैं, उन्हें पूर्ण रूप से प्रतिबंधित किया गया है।',
        Certificates:'हमारे क्षुधा',
        BestGame:'हमारा अनुसरण करें',
        SecurePayment:'सेवाएं',
        terms:'नियम और शर्तें',
        copyBrand:' कॉपीराइट © 2003-{year} 11ic (इंटरनेशनल) लिमिटेड',
    },
    form: {
        IFSC:'IFSC में 8-12 अंकों और अक्षरों का संयोजन होना चाहिए',
        checkMoney1: 'राशी डालें',
        checkMoney2: 'प्रारूप में त्रुटि',
        checkMoney3: 'राशि 0 नहीं हो सकती',
        //
        checkWithdraw: 'वापसी पासवर्ड दर्ज करें',
        //
        checkRealname: 'असली नाम दर्ज करें',
        /***बैंक कार्ड सत्यापित करें*/
        checkBankNumber1: 'बैंक खाता दर्ज करें',
        checkBankNumber2: 'बैंक कार्ड प्रारूप त्रुटि',
        /** शाखा सत्यापित करें*/
        checkBranch: 'शाखा में प्रवेश करें',
        /**ईमेल सत्यापित करें**/
        checkEmail1: 'ईमेल पता दर्ज',
        checkEmail2: 'ईमेल प्रारूप त्रुटि',
        /***आईडी सत्यापित करें*/
        checkCard1: 'आईडी नंबर दर्ज करें.',
        checkCard2: 'पहचान संख्या। प्रारूप में त्रुटि',
        /**फ़ोन नंबर सत्यापित करें.*/
        checkPhone1: 'फ़ोन नंबर दर्ज करें.',
        checkPhone2: 'मान्य फोन नंबर दर्ज करें.',
        /**पासवर्ड को सत्यापित करें */
        checkpwd: 'पास वर्ड दर्ज करें',
        /** पुष्टि पासवर्ड की पुष्टि करें pwd*/
        checkConfirm1: 'पासवर्ड फिर से दर्ज करें',
        checkConfirm2: 'पासवर्ड मैच नहीं कर रहा है',
        /** पुराना पासवर्ड और नया पासवर्ड सत्यापित करें*/
        checkConfirms: 'पुराने और नए पासवर्ड समान हैं',
        /**सत्यापन कोड सत्यापित करें */
        checkVerifiCode1: 'सत्यापन कोड रिक्त नहीं है',
        checkVerifiCode2: 'सत्यापन कोड प्रारूप त्रुटि',
        /** उपयोगकर्ता नाम सत्यापित करें*/
        checkUsername1: 'उपयोगकर्ता नाम दर्ज करें',
        checkUsername2: 'पासवर्ड कोन्टाइनिंग ात लीस्ट ६ लेटर्स एंड नंबर',
        /**मल्टीनेशनल फोन नंबर को वेरीफाई करें*/
        checkPhoneNumber1: 'एक मान्य फ़ोन नंबर दर्ज करें.',
        checkPhoneNumber2: 'फ़ोन नंबर दर्ज करें.',
        /** लॉगिन पासवर्ड सत्यापित करें */
        checkRegisterPassword1: 'लॉगिन पासवर्ड दर्ज करें',
        checkRegisterPassword2: 'पासवर्ड कोन्टाइनिंग ात लीस्ट ६ लेटर्स एंड नंबर',
        /**वास्तविक नाम सत्यापित करें*/
        checkrealName1:'असली नाम खाली नहीं',
        checkrealName2:'No less than two characters',
        /** QQ सत्यापित करें */
        checkQQ1:'QQ खाली नहीं है',
        checkQQ2:'छह अक्षर से कम नहीं',
        /** WeChat सत्यापित करें */
        checkwechat1:' WeChat खाली नहीं है',
        checkwechat2:'दस अक्षर से कम नहीं',
        /** ईमेल सत्यापित करें */
        checkemail1:'ईमेल खाली नहीं है',
        checkemail2:'13 वर्णों से कम और 20 वर्णों से अधिक नहीं',
        checkemail3:'मान्य ईमेल पता दर्ज करें',
        /** पासवर्ड वापस लेने की पुष्टि करें */
        checkwithdrawpwd1:'पासवर्ड खाली न करें',
        checkwithdrawpwd2:'छह अक्षर से कम नहीं',
        checkBankName:'बैंक खाता सत्यापित नहीं हुआ, कृपया बाद में प्रयास करें',
        /** 校验提款密码 */ 
        checkNumber1:'प्लीज  इनपुट  अमाउंट',
        checkNumber2:'इनवैलिड  अमाउंट ，प्लीज  इनपुट  व्होले  नंबर数',
        checkNumber3:'अमाउंट  कन्नोत  बे  0',
        /** 支付金额 **/
        checkPayMoney1:'कृपया जमा राशि का मान दर्ज करें',
        checkPayMoney2:' प्रोत्साहन राशि का प्रारूप',
        checkPayMoney3:'जमा राशि:{min} - {max} INR',
    },
    common: {
        loading: 'लोड हो रहा है',
        loading2: 'इनाम की अद्यतन सूची',
        search: 'खोज',
        tips: 'अनुस्मारक',
        congratulations: 'बधाई हो',
        success: 'सफलता',
        confirmButtonText: 'पुष्टि करें',
        confirmButtonText2: 'उस की नकल करें',
        cancelButtonText:'रद्द करना',
        money: 'THB',
        needLogin: 'लॉग इन करें और चलाएं',
        tryTitle:'मुक्त शर्त के लिए कोई पुरस्कार नहीं, क्या आप जारी रखना चाहते हैं? ', 
        tryTitle2:'क्षमा करें, यह गेम कोई निःशुल्क शर्त नहीं है, अब लॉग इन करें?',
        loginOut: 'लॉग आउट',
        close:'बंद करे',
    },
    timer: {
        finalWeek: 'पिछले एक सप्ताह ',
        finalMonth: 'पिछले एक महीने से',
        finalThreeMonth: 'पिछले तीन महीने',
    },
    state: {
        discountsTypes: {
            all: 'सब',
            rebateBonus: 'कैशबैक बोनस',
            depositDiscount: 'जमा बोनस',
            RescueFund: 'छूट देना',
            UpgradeAward: 'वीआईपी अपग्रेड बोनस',
            WinningAwards: 'वीआईपी बोनस को फिर से हासिल करें',
            OtherPreferences: 'अन्य',
            RegistrationPreferences: 'साइन अप बोनस'
        },
        sports_gameTypes: {
            allGame: 'सभी खेल',
            slots: 'स्लॉट्स',
            live: 'लाइव गेम',
            sport: 'खेल',
            lottery: 'लॉटरी',
            fish: 'फिशर गेम्स',
            chess: 'शतरंज',
            other: 'अन्य'
        }
    },
    filter: {
        status0:'प्रसंस्करण',
        status1:'सफलता',
        status2:'एक्स्पायर्ड',
        status3:'रद्द',
        changeName: {
            allType: 'सभी प्रकार के',
            applying: 'आवेदन करने वाले',
            successfulCollection: 'सफलता का दावा किया',
            finishFlow: 'कारोबार पूरा हुआ',
            cancel: 'पतन',
            Clearance: 'निकासी',
            Unclaimed: 'लावारिस',
            noPrize: 'सम्मानित नहीं किया गया',
        }, 
        bonusTypes: {
            Predividend: 'रिलीज',
            Postdividend: 'जारी करने के बाद',
            Deductdividends: 'कटौती'
        },
        bonusName: {
            rebateBonus: 'कैशबैक बोनस',
            depositDiscount: 'जमा बोनस',
            Invitation: 'रेफरल बोनस',
            signin: "हस्ताक्षर के लिए बोनस",
            ContinuousDeposit: 'लगातार जमा बोनस',
            register: 'साइन अप बोनस',
            RescueFund: 'छूट देना',
            UpgradeAward: 'वीआईपी अपग्रेड बोनस',
            WinningAwards: 'वीआईपी बोनस को फिर से हासिल करें',
            OtherPreferences: 'अन्य',
        },
        bonusLockPlatform:{
            mineAccount: 'मुख्य खाता'
        },
        bonusLockStatus:{
            status1: 'जमे हुए',
            status2: 'फ़्रीज़',
            status4: 'रद्द',
        },
        depositLockStatus:{
            status1: 'जमे हुए',
            status2: 'फ़्रीज़',
            status3: 'जमे हुए'
        },
        gameName:{
            name1: 'स्लॉट्स',
            name2: 'लाइव गेम',
            name3: 'खेल',
            name4: 'लॉटरी',
            name5: 'फिशर गेम्स',
            name6: 'शतरंज',
            name7: '3 डी लॉबी',
        },
        changeTitle:{
            name0:'आवेदन करने वाले',
            name1:'सिस्टम समायोजन',
            name2:'जमा करें',
            name3:'जल्दी वापस लेना',
            name4:'खेल के लिए आयात',
            name5:'खेल के लिए निर्यात करें',
            name8:'प्रमोशन बोनस',
            name9:'मैनुअल जमा',
            name10:'मैनुअल वापस लेना',
            name41:'शर्त',
            name41:'भुगतान',
            name100:'आवेदन करने वाले',
            name11:"लॉटरी की खरीद",
            name12:"लॉटरी भुगतान, यू'ओ बाओ का अनिवार्य मोचन",
            name13:'लॉटरी टिकट रद्द, बेहतर एजेंट स्थानांतरण',
            name14:'लॉटरी दैनिक कार्य',
            name16:'बेहतर एजेंट द्वारा मैनुअल स्थानांतरण',
            name17:"Y UE B गर्व खरीदें",
            name18:"Y UE B गर्व से छुटकारा",
            name19:'4D लॉटरी की खरीद',
            name20:'4D डी लॉटरी पुरस्कार',
            name21:'4D डी लॉटरी रिफंड',
            name22:'खेल लॉटरी की खरीद',
            name23:'खेल लॉटरी पुरस्कार',
            name24:'स्पोर्ट्स लॉटरी रोलबैक',
            name30:'पदोन्नति छूट का निमंत्रण दें',
            name90:'इनाम',
            name91:'शर्त लगाइए',
            name92:'भुगतान का अनुमान है',
            name93:'अनुमान रद्द किया गया',
        },
        withdrawStatus:{
            withdrawStatus0:'आवेदन करने वाले',
            withdrawStatus1:'出款中',
            withdrawStatus2:'成功',
            withdrawStatus3:'拒绝',
            withdrawStatus4:'出款中',
            withdrawStatus5:'出款中',
        }
        
    },
    catchFish:{
        in:'in',
        income:'दोहरी आय',
        Deepsealive:'डीप सी लाइव',
        Deepsealive2:'रियल-टाइम अपडेट',
        time:'कुछ देर पहले',
        time2:'catched',
        time3:'एक',
        fishKing:'पिछले सप्ताह मत्स्य पालन राजा',
        fishKing2:'हर मंगलवार को अद्यतन',
    },
    invitation:{
        title:'दोस्तों को देखें',
        title2:'एक मित्र लिंक देखें',
        title3:'मेरा दोस्त',
        copy:'कापी',
        registereduser:'पंजीकृत उपयोगकर्ता',
        time:'समय',
        InviteeStatus:'आमंत्रित करने की स्थिति',
        BonusStatus:'बोनस की स्थिति',
        Received:'दावा किया',
        receive:'दावा',
        expired:'समय सीमा समाप्त',
        ActivityRules:'पदोन्नति नियम:',
        ActivityRules2:'कृपया आमंत्रित करें कि पहले व्यक्ति पर इनाम का दावा करेआमंत्रित किया जा रहा है भी कमा सकते हैं',
        CopySuccessful:'सफलता की प्रतिलिपि बनाई गई',
        successReceived:'sसफलता का दावा किया',
        unregistered:'unregistered',
        registered:'registered',
    },
    jackpot:{
        Listofwinners:'विजेताओं',
        accountNumber:'खिलाड़ियों की सूची',
        game:'खेल',
        bonus:'बक्शीश',
    },
    marquree:{
        Notice:'नोटिस',
        Close:'बंद करे',
    },
    betting: {
        title: 'शर्त',
        needLogin: 'आप अभी तक लॉग इन नहीं हुए है！',
        AvailableBalance: 'अवेलेबल बैलेंस',
        betSuccess: 'सफल सट्टेबाजी！',
        recharge: 'रिचार्ज',
        inLottery: 'खींचना',
        rule: 'रूल्स',
        issues: 'टियर',
        rules: 'बेटिंग  रूल्स',
        betSubmit: 'प्लेस  बेट',
        addcart: 'ऐड  तो  कार्ट',
        clear: 'क्लियर',
        add: 'ज्वाइन',
        totalTxt: 'टोटल',
        noselected: 'सेलेक्ट  लकी  नंबर्स ！',
        noEnoughMoney: 'नो  एनफ  बैलेंस',
        Count:'नंबर ऑफ़ बेटस ',
        Amount:'अमाउंट',
        betNow:' प्लेस  बेट',
        Total:'टोटल',
        return:'वापसी',
        TotalCount:'टोटल  बेटिंग',
        TotalAmount:'टोटल  अमाउंट',
        TotalWinLost:'टोटल  विन  लोस्स',
        settleType: {
            all: 'आल',
            Bets:'दांव',
            noSettle: 'उनसेतटले',
            settle: 'सेटल',
            win: 'विन',
            lose: 'लूज़',
            refund: 'प्रधान वापसी',
            PlaceBets:'जगह दांव',
            ClearAll:'स्पष्ट सब',
            cost:'लागत',
            NumberofBets:'दांव की संख्या',
            tips:'अनुस्मारक: वर्तमान पृष्ठ केवल GT क्रिकेट, BTI, IBC, EXCHANGE सट्टेबाजी रिकॉर्ड के सट्टेबाजी रिकॉर्ड को प्रदर्शित करता है, कृपया अन्य खेलों में देखें',
        },
        trafficList: {
            0: 'नंबर',
            10: 'रेड',
            12: 'बुले',
            11: 'येलो',
        },
        cartHead: {
            type: 'टाइप',
            details: 'डिटेल्स',
            multiple: 'विभिन्न',
            money: 'अमाउंट'
        },
        lotteryTab: {},
        countDown: '距下一期',
        record: {
            title1: 'ड्रा हिस्ट्री',
            title2: 'माय बेटिंग हिस्ट्री',
            title: 'बेटिंग डिटेल्स',
            orderNo: 'टिकट्स नंबर',
            betMoney: 'बेट अमाउंट',
            dealMoney: 'अमाउंट',
            serviceAmount: 'सर्विस फी',
            drawNum: 'ड्रा नंबर',
            betNum: 'बेट नंबर',
            status: 'स्टेटस',
            rewards: 'रिवार्ड्स',
            betTime: 'बेटिंग टाइम',
            tableHead: {
              Period: 'टियर',
              Price: 'जैकपोट',
              Numbers: 'ड्रा नंबर्स',
              Result: ' रिजल्ट्स'
            },
        }
    },
    createdDislaog:{
        diaTitle:'स्वागत हे',
        signTitle:'एक नि: शुल्क खाता बनाए',
        sigupSuccess:'स्वागत हे!',
        staytuned:'बने रहें',
        prove:'कृपया बीच में केवल एक स्थान के साथ संख्या या अक्षर दर्ज करें',
        Announcement:"घोषणा"
    },
    wheel:{
        WinningRecord:'माय लकी ड्रा विनिंग रिकॉर्ड',
        Remaining:'चा हुआ लकी ड्रा टाइम्स',
        Times:'बार',
        Start:'शुरू',
        NoWinningRecord:'कोई जीतने का रिकॉर्ड नहीं',
        Loading:'लोड हो रहा है...',
        Delivered:'पहुंचा दिया',
        service:'सर्विस',
        GoodLuck:'सौभाग्य, जीत',
        prize:'भव्य पुरस्कार',
        HurryReceive:'इसे प्राप्त करने के लिए ग्राहक सेवा से संपर्क करें',
        BONUS:'इनाम भेजा गया।कृपया लेनदेन रिकॉर्ड की जांच करें',
        remainingtimes:'आपकी शेष लॉटरी 0 गुना है',
        Iknow:'मैं जानता हूँ',
        determine:'पुष्टि करें',
        cancel:'रद्द करना',
        confirm:' तुरंत याद दिलाना',
        message:'लकी ड्रा जारी है, कृपया बार-बार क्लिक न करें!',
    },
    ghistory: {
		title: 'Bet Detail',
        Playerid: 'Player ID',
        gameid: 'Game ID',
        insurance: 'insurance',
        WinorLoss: 'कुल जीत / हार',
        betTime: 'बेट टाइम',
        orderNo: 'Txn. ID',
        Status: 'स्थिति',
        Provider: 'Provider',
        Event: 'Event',
        betArea: 'Bet area',
        gameName: 'Game name',
        total: "कुल",
        Odds: 'Odds',
        TotalBets: 'कुल दांव',
        ValidBets: 'Valid Bets',
        WinorLoss2: 'Win/Loss',
        close: 'बंद करे',
        Running: 'Running',
        Settled: 'बसे हुए',
        Game: 'Game',
	},
    ...hiLocale
}

export default hi_IN


// WEBPACK FOOTER //
// ./src/pages/build902/i18n/langs/HI_IN.js